(function () {
  class FreeSpinsIntro extends PIXI.Container {
    constructor() {
      super();

      this._callback = undefined;

      this.visible = false;

      this.numSpins = undefined;

      this.continueButton = undefined;

      this.continueUp = undefined;
      this.continueDown = undefined;
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this.baseName = "featurePopupContainer:freespinsIntroPopup";
      this.wolves = resourceManager.get(`${this.baseName}:wolves`);

      this.inFreespins = resourceManager.get(
        `${this.baseName}:wolves:inFreespins`
      );

      this.congratulationsText = resourceManager.get(
        `${this.baseName}:wolves:congratulations`
      );

      this.numSpins = resourceManager.get(`${this.baseName}:wolves:numSpins`);

      this.continueButton = resourceManager.get(
        `${this.baseName}:wolves:continueButton`
      );

      this.continueUp = resourceManager.get(
        `${this.baseName}:wolves:continueButton:continueUp`
      );

      this.continueDown = resourceManager.get(
        `${this.baseName}:wolves:continueButton:continueDown`
      );

      this.continueUp.interactive = false;

      this.popupMaskDimObject = resourceManager.get(
        "featurePopupContainer:darkBackground"
      );
    }

    setup() {
      resourceManager.get(this.baseName).visible = true;

      // wait for click - anywhere on screen
      this.continueUp.interactive = true;
      this.continueUp.mousedown = this.continueUp.touchstart =
        this.closeDialog.bind(this);
    }

    showIntro(numFS, callback) {
      this.setup();
      this._callback = callback;

      this.numSpins.setText(numFS);

      // TODO: HB: Timeline this
      gsap.fromTo(
        [this.popupMaskDimObject, this],
        {
          alpha: 0,
        },
        {
          delay: 0.5,
          alpha: 1,
          duration: 0.5,
          onStart: () => {
            soundManager.play("dim");
            this.popupMaskDimObject.visible = true;
          },
          onComplete: () => {},
        }
      );

      gsap.fromTo(
        this.wolves,
        {
          y: this.wolves.y + 700,
        },
        {
          delay: 0.5,
          y: this.wolves.y,
          duration: 0.3,
          onStart: () => {},
          onComplete: () => {},
        }
      );

      gsap.fromTo(
        this.congratulationsText,
        {
          alpha: 0,
          y: this.congratulationsText.y - 100,
        },
        {
          delay: 1,
          alpha: 1,
          y: this.congratulationsText.y,
          duration: 0.3,
          onStart: () => {},
          onComplete: () => {},
        }
      );

      gsap.fromTo(
        [this.inFreespins, this.numSpins],
        {
          alpha: 0,
        },
        {
          delay: 1.3,
          alpha: 1,
          duration: 0.3,
          onStart: () => {},
          onComplete: () => {},
        }
      );

      gsap.fromTo(
        this.continueButton,
        {
          alpha: 0,
        },
        {
          delay: 1.6,
          alpha: 1,
          duration: 0.3,
          onStart: () => {},
          onComplete: () => {},
        }
      );
    }

    closeDialog() {
      const self = this;
      this.popupMaskDimObject.visible = false;
      // turn off click processing
      this.continueUp.interactive = false;
      this.continueUp.mousedown = this.continueUp.touchstart = undefined;

      this.continueUp.visible = false;
      this.continueDown.visible = true;

      resourceManager.get(self.baseName).visible = false;
      timerManager.addTimer(
        1000,
        function () {},
        function () {
          // TODO: HB: Animate the frame disappearing
          self.continueUp.visible = true;
          self.continueDown.visible = false;

          self._callback();
        }
      );
    }
  }
  let freeSpinsIntroCreator = function (json) {
    return new FreeSpinsIntro();
  };
  let freeSpinsIntroInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };
  let freeSpinsIntroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "FreeSpinsIntro",
    freeSpinsIntroCreator,
    freeSpinsIntroInitialiser,
    freeSpinsIntroFilesRequired
  );
})();
